'use client';

import React from 'react';
import DynamicTabs from '@components/DynamicTabs';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import WimbledonAroundData from './WimbledonAroundData';
import CustomImage from '@components/CustomImage';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';

export default function WimbledonBridgeAround(props: any) {
  const data = props.locale.section?.wimbledonBridgeGettingAroundData || [];
  const tabs = data.map((item: any) => ({
    title: item.title || '',
    icon: item.icon || '',
    content: (
      <WimbledonAroundData
        tabDescription={item.description || []}
        type={item.title || ''}
      />
    ),
  }));

  return (
    <Stack
      className={cn.wimbledonBridgeAround}
      component="section"
      id="wimbledonBridgeAroundID"
    >
      <CommonContainer
        maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
        flexGrow={1}
      >
        <Box className={cn.wimbledonAroundBlock}>
          <Box className={cn.wimbledonAroundContent}>
            <ParallaxText
              variant="h4"
              animationType="zoomIn"
              animationDuration={500}
            >
              {ReactHtmlParser(
                props.locale.section['wimbledonBridgeGettingAroundHeading']
              )}
            </ParallaxText>
            <DynamicTabs
              tabs={tabs}
              className={cn.wimbledonBridgeAroundTabs}
              elementClass={cn.wimbledonBridgeAroundElement}
              tabClass={cn.wimbledonBridgeAroundNavigation}
              listClassName={cn.wimbledonBridgeAroundList}
              itemClassName={cn.wimbledonBridgeAroundItem}
              linkClass={cn.wimbledonBridgeAroundLink}
              tabIconClass={cn.wimbledonBridgeAroundIcon}
              contentClass={cn.wimbledonBridgeAroundContent}
              activeClassName={cn.wimbledonBridgeAroundActive}
            />
          </Box>
          <Box className={cn.wimbledonAroundMap}>
            <Box className={cn.wimbledonAroundMap__element}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d7037.192311991992!2d-0.20845963032417195!3d51.421000421007804!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1770886463702!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </Box>
          </Box>
        </Box>
      </CommonContainer>
    </Stack>
  );
}
